import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkRideStatusReceived = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const bulkStatusReceivedRidesProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkRideStatusReceived,
    entity,
  );
  const bulkStatusReceivedRidesProcess = useRecoilValue(
    activeProcessSF(bulkStatusReceivedRidesProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkRideStatusReceived,
      toastSummaryOnComplete: true,
      process: bulkStatusReceivedRidesProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
    });
  }, [
    bulkStatusReceivedRidesProcess,
    entity,
    onComplete,
    stopProcessPolling,
    t,
  ]);
};
